export const BLUE_BUTTON = "#3B4EFF";
export const RED_BUTTON = "#bd1a23";
export const YELLOW_BUTTON = "rgb(235, 169, 62)";
export const GREEN_BUTTON = "rgb(27, 200, 138)";
export const GREY_BUTTON = "#b0b0b0";
export const WHITE = "#fff";
export const BLACK = "#000";
